import { useEffect, useState } from 'react';
import ProductChooser from '../orders/create/productChooser';
import { NXDelete, NXSearch } from '../../icons';
import InputField from './InputField';

import { formatCurrency } from './utils';

function ProductWithVariantSearch({ value, onVariantChange, usedIn }: {value?:any, onVariantChange: (variantData: any[]) => void, usedIn: 'purchase' | 'order' | 'stock_transfer' }) {


  const [openProductChooser, setOpenProductChooser] = useState(false);
  const [variantData, setVariantData] = useState<any>([]);
  const [searchQuery, setSearchQuery] = useState<string>("");


  const onAddVariantChooser = (variant: any) => {
    setOpenProductChooser(false);
    const updatedVariant = Array.from(variant).map((item: any) => ({
      ...item,
      quantity: 1,
      ...(usedIn === 'purchase' && { unit_cost: 0 }),
    }));

    setVariantData((prevCartItems: any) => [
      ...(prevCartItems || []), 
      ...updatedVariant
    ]);


    onVariantChange([...(variantData || []), ...updatedVariant]);

  };



  const handleSearch = (e: any) => {
    const svalue = e.target.value;
    setSearchQuery(svalue);
    setOpenProductChooser(svalue.length > 0);
  };

  const onQuantityChange = (e: any, index: number) => {
    const qvalue = e.target.value;
    if (/^\d*$/.test(qvalue)) { // Allows only numbers or an empty string
      setVariantData((prevItems: any = []) => {
        const updatedVariants = [...prevItems];
        if (updatedVariants[index]) {
          updatedVariants[index] = {
            ...updatedVariants[index],
            quantity: qvalue, // Keep it as a string temporarily
          };
        };
        onVariantChange(updatedVariants);
        return updatedVariants;
      });
    }
  };

  const onQuantityBlur = (index: number) => {
    setVariantData((prevItems: any = []) => {
      const updatedVariants = [...prevItems];
      if (updatedVariants[index]) {
        updatedVariants[index] = {
          ...updatedVariants[index],
          quantity: parseInt(updatedVariants[index].quantity, 10) || 1, // Default to 1 if empty
        };
      };
      onVariantChange(updatedVariants);
      return updatedVariants;
    });
  };
  
  

  const onUnitCostChange = (e: any, index: number) => {
    const uvalue = e.target.value;
    // Validate the input to ensure it matches a decimal number pattern
    if (/^\d*\.?\d*$/.test(uvalue)) {
      setVariantData((prevItems: any = []) => {
        const updatedVariants = [...prevItems];
        if (updatedVariants[index]) {
          updatedVariants[index] = {
            ...updatedVariants[index],
            unit_cost: uvalue, // Keep as string for now
          };
        };
        onVariantChange(updatedVariants);
        return updatedVariants;
      });
    }
  };

  
  
    const handleRemoveCartItem = (index: number) => {
        setVariantData((prevItems: any) => {
            const updatedVariants = prevItems.filter((_: any, i: number) => i !== index);
            onVariantChange(updatedVariants);
            return updatedVariants;
        });
    };

    // useEffect(() =>   {
    //     onVariantChange(variantData);
    // }, [variantData]);

    useEffect(()=>{
      if(value?.length){
        setVariantData(value)
      }
    }, [value])

  return (
    <>
        <div>
            <div className="flex items-center w-full mb-4">
                <div className="relative flex-grow">
                    <NXSearch className="absolute top-1/2 left-4 transform -translate-y-1/2" />
                <InputField
                        type="text"
                        placeholder="Search by ID, product, or others..."
                        onChange={handleSearch}
                        value={searchQuery}
                        className="p-[12px] bg-secondary-50 rounded-lg border-none outline-none pl-[3.1rem] w-full"
                    />
                </div>
                <button
                onClick={() => setOpenProductChooser(true)}
                type="button"
                className="ml-4 inline-flex justify-center rounded-md border border-transparent px-4 py-2 bg-primary-600 text-base font-medium text-white shadow-sm hover:bg-primary-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm w-[150px]"
                >
                Browse
                </button>
            </div>
        </div>


        {variantData?.length ? (
        <table className="min-w-full divide-y divide-gray-200 shadow border-b">
        
          <thead>
            <tr>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Product
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Quantity
              </th>
              {usedIn === 'purchase' && (
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Cost Per Unit
                </th>
              )}
                {usedIn !== 'stock_transfer' && (
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Total
                </th>
                )}
              <th scope="col" className="px-6 py-3"></th>
            </tr>
          </thead>
        
          <tbody>
           {variantData?.map((item: any, index: number) => (
              <tr key={index} className="bg-white">
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center">
                    <div className="ml-4">
                      <div className="text-sm font-medium text-gray-900">{item?.variantName}</div>
                      <div className="text-sm text-gray-500">{formatCurrency(item.price)}</div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <InputField
                    type="number"
                    min="1"
                    value={item.quantity}
                    onChange={(e) => {onQuantityChange(e, index)}}
                    onBlur={() => onQuantityBlur(index)}
                    className="w-16 border rounded p-1"
                  />
                </td>
                {usedIn === 'purchase' && (
                    <td className="px-6 py-4 whitespace-nowrap">
                   <InputField
                        type="text"
                        value={item.unit_cost}
                        onChange={(e) => {onUnitCostChange(e, index)}}
                        className="w-16 border rounded p-1"
                        />
                    </td>
                )}

                {usedIn !== 'stock_transfer' && (
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {formatCurrency((item.quantity * (usedIn === 'purchase' ? item.unit_cost : item.price)))}

                    
                  </td>
                )}

                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                  <button
                    type="button"
                    onClick={() => handleRemoveCartItem(index)}
                    className="text-red-600 hover:text-red-900"
                  >
                    <NXDelete />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>  ) : <p>No Variant Selected</p>}




        {openProductChooser && (
            <ProductChooser
            isOpen={openProductChooser}
            parentSearchTerm={searchQuery}
            onClose={() => setOpenProductChooser(false)}
            filterOn='products'
            onAdd={onAddVariantChooser}
            />
        )}

    </>
  );
}

export default ProductWithVariantSearch;
